<div class="marketing-content py-12 md:py-16 max-w-7xl">
  <!-- Left Column: Content -->
  <div class="space-y-10 max-w-xl">
    <div class="flex items-center space-x-2">
      <h1 class="az-logo text-5xl">fasten</h1>
      <span class="px-3 py-1 text-sm font-medium bg-indigo-50 text-[#5B47FB] rounded-full">BETA</span>
    </div>
    <div class="space-y-6">
      <h2 class="text-6xl font-bold text-gray-900 leading-[1.1] tracking-tight">Your health data, <span class="text-[#5B47FB]">unified</span></h2>
      <div class="space-y-6">
        <div class="flex items-start space-x-4">
          <div class="mt-1 flex-shrink-0 bg-indigo-50 rounded-full p-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-[#5B47FB]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-gray-900">Secure Access</h3>
            <p class="text-gray-600">Safely connect your health records to trusted apps and services</p>
          </div>
        </div>
        <div class="flex items-start space-x-4">
          <div class="mt-1 flex-shrink-0 bg-indigo-50 rounded-full p-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-[#5B47FB]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-gray-900">Full Control</h3>
            <p class="text-gray-600">Control your data sharing preferences with a simple tap</p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-12">
      <div class="flex flex-col items-start space-y-4">
        <button
          (click)="signinWithIdentityProvider(CspType.ClearCsp)"
          [disabled]="loading"
          type="button"
          class="clear-button flex items-center justify-center px-5 py-3 text-white">
          <img src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 353.2 337.6' style='enable-background:new 0 0 353.2 337.6;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bdisplay:none;%7D .st1%7Bdisplay:inline;fill:%23192958;%7D .st2%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cg id='BKGD' class='st0'%3E%3Crect class='st1' width='353.2' height='337.6'/%3E%3C/g%3E%3Cg id='Layer_2'%3E%3Cg%3E%3Cg%3E%3Ccircle class='st2' cx='14' cy='168.5' r='14'/%3E%3Ccircle class='st2' cx='77.1' cy='168.5' r='14'/%3E%3Ccircle class='st2' cx='51.3' cy='209.8' r='14'/%3E%3Ccircle class='st2' cx='96.6' cy='227.8' r='14'/%3E%3Ccircle class='st2' cx='99.4' cy='276.8' r='14'/%3E%3Ccircle class='st2' cx='51.3' cy='127.1' r='14'/%3E%3Ccircle class='st2' cx='45.5' cy='72.8' r='14'/%3E%3Ccircle class='st2' cx='96.6' cy='108.7' r='14'/%3E%3Ccircle class='st2' cx='98.4' cy='61.7' r='14'/%3E%3Ccircle class='st2' cx='145.9' cy='72.8' r='14'/%3E%3Ccircle class='st2' cx='207.1' cy='72.8' r='14'/%3E%3Ccircle class='st2' cx='253.3' cy='61.1' r='14'/%3E%3Ccircle class='st2' cx='256.5' cy='109.7' r='14'/%3E%3Ccircle class='st2' cx='301.9' cy='127.1' r='14'/%3E%3Ccircle class='st2' cx='301.9' cy='209.8' r='14'/%3E%3Ccircle class='st2' cx='256.5' cy='227.9' r='14'/%3E%3Ccircle class='st2' cx='308.1' cy='264.2' r='14'/%3E%3Ccircle class='st2' cx='207.1' cy='264.2' r='14'/%3E%3Ccircle class='st2' cx='145.9' cy='264.2' r='14'/%3E%3Ccircle class='st2' cx='45.1' cy='264.2' r='14'/%3E%3Ccircle class='st2' cx='253.3' cy='276.8' r='14'/%3E%3Ccircle class='st2' cx='176.3' cy='301.5' r='14'/%3E%3Ccircle class='st2' cx='226.7' cy='323.6' r='14'/%3E%3Ccircle class='st2' cx='126.6' cy='323.6' r='14'/%3E%3Ccircle class='st2' cx='276.5' cy='168.5' r='14'/%3E%3Ccircle class='st2' cx='339.2' cy='168.5' r='14'/%3E%3Ccircle class='st2' cx='308.1' cy='72.8' r='14'/%3E%3Ccircle class='st2' cx='176.3' cy='35.5' r='14'/%3E%3Ccircle class='st2' cx='126.2' cy='14' r='14'/%3E%3Ccircle class='st2' cx='226.8' cy='14' r='14'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
             class="px-[8px]"
             style="height: 24px; display: inline; vertical-align: bottom;"/>
          Sign in with CLEAR
        </button>

        <button
          data-testid="idme-button"
          (click)="signinWithIdentityProvider(CspType.IdmeCsp)"
          [disabled]="loading"
          type="button"
          class="clear-button idme-button flex items-center justify-center gap-2 px-5 py-3 text-white">
          <span class="text-base font-semibold">Sign in with</span>
          <img [src]="idmeButtonLogoSrc" alt="ID.me" class="h-5 align-middle" />
        </button>
      </div>

      <div *ngIf="errorMsg" class="mt-4 w-full max-w-[328px] rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
        {{errorMsg}}
      </div>

      <div class="text-sm text-gray-500 mt-6 flex gap-1">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>Need help? <a href="#" class="text-[#5B47FB] hover:text-[#4936E8] font-medium">Learn more</a></span>
      </div>
    </div>
  </div>

  <!-- Right Column: Illustration -->
  <div class="hero-illustration max-w-2xl mx-auto md:mx-0 px-8 md:px-0">
    <svg viewBox="0 0 500 400" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full transform scale-110 drop-shadow-2xl">
      <!-- Background Circle -->
      <circle cx="250" cy="200" r="150" fill="#F3F4F6" class="pulse-animation"/>

      <!-- Central Device -->
      <g class="float-animation">
        <rect x="200" y="120" width="100" height="160" rx="12" fill="white" stroke="#5B47FB" stroke-width="2"/>
        <rect x="210" y="130" width="80" height="120" rx="4" fill="#EEF2FF"/>
        <g>
          <rect x="220" y="140" width="60" height="8" rx="4" fill="#5B47FB" opacity="0.6"/>
          <rect x="220" y="156" width="40" height="8" rx="4" fill="#5B47FB" opacity="0.4"/>
          <circle cx="240" cy="180" r="15" fill="#5B47FB" opacity="0.2"/>
        </g>
      </g>

      <!-- Health Data Elements -->
      <g>
        <!-- Medical Record (Top) -->
        <g class="float-animation" style="animation-delay: -1s">
          <rect x="120" y="40" width="60" height="80" rx="8" fill="white" stroke="#5B47FB" stroke-width="2"/>
          <path d="M135 80h30M135 60h30M135 100h30" stroke="#5B47FB" stroke-width="2"/>
          <path d="M150 120L200 120" stroke="#5B47FB" stroke-width="1" stroke-dasharray="4 4" class="connection-line"/>
        </g>

        <!-- Heart Rate Monitor (Right) -->
        <g class="float-animation" style="animation-delay: -2s">
          <rect x="340" y="160" width="70" height="60" rx="8" fill="white" stroke="#5B47FB" stroke-width="2"/>
          <path d="M350 190h10l10-20l10 40l10-20h10" stroke="#5B47FB" stroke-width="2"/>
          <path d="M340 190L300 200" stroke="#5B47FB" stroke-width="1" stroke-dasharray="4 4" class="connection-line"/>
        </g>

        <!-- Lab Results (Left) -->
        <g class="float-animation" style="animation-delay: -3s">
          <rect x="90" y="160" width="70" height="70" rx="8" fill="white" stroke="#5B47FB" stroke-width="2"/>
          <path d="M110 180h30M110 195h30M110 210h30" stroke="#5B47FB" stroke-width="2"/>
          <path d="M160 195L200 200" stroke="#5B47FB" stroke-width="1" stroke-dasharray="4 4" class="connection-line"/>
        </g>

        <!-- Security Shield (Bottom Right) -->
        <g class="float-animation" style="animation-delay: -4s">
          <rect x="320" y="280" width="70" height="70" rx="8" fill="white" stroke="#5B47FB" stroke-width="2"/>
          <path d="M355 295c0 20-10 25-17.5 27.5 7.5 2.5 17.5 7.5 17.5 27.5 0-20 10-25 17.5-27.5-7.5-2.5-17.5-7.5-17.5-27.5z" stroke="#5B47FB" stroke-width="2" fill="white"/>
          <path d="M320 315L300 280" stroke="#5B47FB" stroke-width="1" stroke-dasharray="4 4" class="connection-line"/>
        </g>
      </g>

      <!-- Floating Particles -->
      <g class="pulse-animation">
        <circle cx="140" cy="30" r="3" fill="#5B47FB" opacity="0.6"/>
        <circle cx="380" cy="150" r="3" fill="#5B47FB" opacity="0.6"/>
        <circle cx="360" cy="320" r="3" fill="#5B47FB" opacity="0.6"/>
        <circle cx="80" cy="180" r="3" fill="#5B47FB" opacity="0.6"/>
      </g>
    </svg>
  </div>
</div>
